import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { CarBusinessLine } from "src/app/public/car/constants/car-basic-data";
import { AppFunctions } from "../../constants/app-functions";

import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";

@Component({
    selector: 'table-dialog',
    templateUrl: 'table-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatTableModule]
})
  export class TableDialogComponent {

    CarBusinessLine = CarBusinessLine

    constructor(
      public dialogRef: MatDialogRef<TableDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: {priceHistory: [], businessLine: CarBusinessLine, label: string},
      
    ) {}
  
    onNoClick(): void {
      //this.dialogRef.
      this.dialogRef.close();
    }

    moneyFormat(s: string): string{
      return AppFunctions.numberWithSpaces(s);
    }
  
    dateFormat(dt: string): string{
  
      return AppFunctions.stringToDatetime(dt);
    }
  }